function toInt(value) {
  return value && parseInt(value);
}

const options = {
  groups: {
    featureFlags: ['permissions.sql.*'],
    customize: ['.*customDimensions.max.*']
  }
};

const fields = {
  'permissions.subtenancy.advancedMode': {
    label: 'Advanced MKP'
  },
  'permissions.subtenancy.disableVizTypeChanges': {
    label: 'Disable Visualization Changes'
  },
  'permissions.subtenancy.maxTenants': {
    label: 'Max Tenants',
    rules: 'numeric|min:0',
    transform: { out: toInt }
  },
  'permissions.synthetics.no_credit_limits': {
    label: 'Disable Synthetics Credit Limits'
  },
  'permissions.synthetics.bgpTests.enabled': {
    label: 'Enable BGP Tests'
  },
  'permissions.synthetics.bgpTests.reachability.enabled': {
    label: 'Enable BGP Reachability'
  },
  'permissions.synthetics.throughputTesting.enabled': {
    label: 'Enable Throughput Testing'
  },
  'permissions.synthetics.transactionTests.enabled': {
    label: 'Enable Transaction Tests'
  },
  'permissions.synthetics.subtestRollup.enabled': {
    label: 'Enable Subtest Rollup Alerts'
  },
  'permissions.synthetics.dataExplorer.enabled': {
    label: 'Enable Synth Data Explorer'
  },
  'permissions.synthetics.ksynthCapability.enabled': {
    label: 'Enable Synth UA Capability'
  },
  'permissions.customDimensions.maxDimensions': {
    label: 'Custom Dimension Limit',
    rules: 'numeric|min:0',
    transform: { out: toInt }
  },
  'permissions.customDimensions.maxPopulators': {
    label: 'Populator Limit',
    rules: 'numeric|min:0',
    transform: { out: toInt }
  },
  'permissions.alerts.limits.keysPerPolicy': {
    label: 'Keys Per Policy Limit',
    rules: 'numeric|min:0|max:20000'
  },
  'permissions.alerts.limits.baselineKeysPerPolicy': {
    label: 'Baseline Keys Per Policy Limit',
    rules: 'numeric|min:0|max:20000'
  },
  'permissions.alerts.nmsNative.enabled': {
    label: 'NMS Native Alerting'
  },
  'permissions.alerts.allow30sPolicyWindow': {
    label: 'Allow Policy Windows Under 60s'
  },
  'permissions.alerts.flowSpec.enabled': {
    label: 'FlowSpec'
  },
  'permissions.alerts.eventAlerting.enabled': {
    label: 'Event Based Alerting'
  },
  'permissions.alerts.mit2bgp.enabled': {
    label: 'Adaptive Flowspec'
  },
  'permissions.ott.enabled': {
    label: 'OTT Analytics'
  },
  'permissions.ott.projected': {
    label: 'OTT IQ Classification UI'
  },
  'permissions.cdn.enabled': {
    label: 'CDN Analytics'
  },
  'permissions.marketIntel.enabled': {
    label: 'Market Intelligence'
  },
  'permissions.rawFlow.viewer': {
    label: 'Standard'
  },
  'permissions.rawFlow.forensicViewer': {
    label: 'Forensic'
  },
  'permissions.suppressLinksInExports': {
    label: 'Suppress Links in Exports'
  },
  'permissions.segmentRouting.enabled': {
    label: 'Experimental Segment Routing'
  },
  'permissions.dashboards.max': {
    label: 'Dashboard Limit',
    transform: { out: toInt }
  },
  'permissions.reportSubscriptions.max': {
    label: 'Subscription Limit',
    transform: { out: toInt }
  },
  'permissions.kubeMap.enabled': {
    label: 'Kube Map'
  },
  'permissions.linkSharing.disabled': {
    label: 'Link Sharing',
    transform: {
      in: (value) => !value,
      out: (value) => !value
    }
  },
  'permissions.portal.enabled': {
    label: 'Portal Access',
    defaultValue: true
  },
  'permissions.ude': {
    label: 'Universal Data Explorer'
  },
  'permissions.embedded_ude': {
    label: 'Embedded UDE Views'
  },
  'permissions.recon.enabled': {
    label: 'NMS (Recon)'
  },
  'permissions.recon.useNLKMQ': {
    label: 'NMS: NLQ'
  },
  'permissions.recon.deviceConfigFetch.enabled': {
    label: 'Device Command Access'
  },
  'permissions.recon.allowSpoofedCommands': {
    label: 'Allow Commands by Spoofed Users'
  },
  'permissions.contextName.enabled': {
    label: 'SNMP v3 Context Name'
  },
  'permissions.kaizen': {
    label: 'AI Advisor (Kaizen)'
  },
  'permissions.aiModels': {
    label: 'AI Providers & Models'
  },
  'permissions.disableKentikAi': {
    label: 'Disable Kentik AI'
  },
  'permissions.disableAiForSpoofed': {
    label: 'Block Kentik AI for Spoofed Kentik Users'
  },
  'permissions.aiInvestigation.enabled': {
    label: 'AI Auto Investigation'
  },
  'permissions.aiInvestigation.limit': {
    label: 'AI Auto Investigation Daily Limit',
    rules: 'numeric|min:0',
    transform: { out: toInt }
  },
  'permissions.aiAlertCorrelation.enabled': {
    label: 'AI Alert Correlations'
  },
  'permissions.tokenAnalytics.enabled': {
    label: 'Token Analytics'
  },
  'permissions.aiMcpServers.enabled': {
    label: 'MCP Servers'
  },
  'permissions.tsp': {
    label: 'TSP (Baselines, Forecasting)'
  },
  'permissions.boundaryasn_override.enabled': {
    label: 'Manually Override Boundary ASN'
  },
  'permissions.kproxyCapability.enabled': {
    label: 'Flow Proxy (Edge Processing) Capability'
  },
  'permissions.kproxyCapability.allowIpObfuscation': {
    label: 'Flow Proxy (Edge Processing) IP Obfuscation'
  },
  'permissions.cloud.metadataless_cloud_exports': {
    label: 'Configure Metadataless Cloud Exports'
  },
  'permissions.cloud.generate_topology_summaries': {
    label: 'Generate Topology Summaries for Cloud Exports'
  },
  'permissions.cloud.write_api_status_to_pg': {
    label: 'Write Cloud Export API Status to Postgres'
  },
  'permissions.recon.uaFlowEnrichment.enabled': {
    label: 'UA SNMP Polling for Flow Enrichment'
  },
  'permissions.icv3.enabled': {
    label: 'Enabled'
  },
  'permissions.ktrafficCapability.enabled': {
    label: 'Flow Proxy (Forwarding) Capability'
  },
  'permissions.kmetaCapability.enabled': {
    label: 'Metadata Capability'
  },
  'permissions.legacyKprobe.enabled': {
    label: 'Legacy Kprobe'
  },
  'permissions.sqlQueryApi.enabled': {
    label: 'SQL Query API'
  },
  'permissions.legacyKproxyAgents.enabled': {
    label: 'Kproxy Agents Page'
  },
  'permissions.globalFilters.enabled': {
    label: 'Global Filters'
  },
  'permissions.kptrCapability.enabled': {
    label: 'Reverse DNS'
  },
  'permissions.kbgpCapability.enabled': {
    label: 'BGP Proxy Capability'
  },
  'permissions.kproxyAutoCreate.enabled': {
    label: 'Kproxy Auto-Create Devices'
  },
  'permissions.recon.guidedMetricsExplorer.enabled': {
    label: 'Guided Metrics Explorer'
  },
  'permissions.recon.templateRunOnlySelected.enabled': {
    label: 'Allow "Run Only Selected Reports" in Monitoring Profile'
  },
  'permissions.monitoringTemplate.essentials.enabled': {
    label: 'Enable Managed Monitoring Profiles'
  },
  'permissions.monitoringTemplate.modernMonitoringTemplateForm.enabled': {
    label: 'Modern Monitoring Profile Form'
  },
  'permissions.recon.customNmsReports.enabled': {
    label: 'Allow custom NMS SNMP Reports'
  },
  'permissions.runbooks.enableGlobal': {
    label: 'Global Runbooks'
  },
  'permissions.assetTags.enabled': {
    label: 'Asset Tags'
  },
  'permissions.serviceNowIntegrationPackages.enabled': {
    label: 'ServiceNow Integration Package Access'
  }
};

export { fields, options };
